import { memo } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'

import { Box, Title } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { isFactorialIdUser } from 'modules/core/lib/factorialIdTokenRefresh'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

import { navigateRoot } from 'modules/authentication/components/_CompanySwitcher'
import CompanySelector from 'modules/authentication/components/_CompanySwitcher/CompanySelector'
import { redirectToFactorialIdCompanySelector } from 'modules/factorial_id/lib/companySelectorRedirect'

function CompanySelectorPage() {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const location = useLocation()

  const returnTo = location.state?.returnTo
  const handleChoice = returnTo ? () => navigate(returnTo) : navigateRoot

  // Factorial ID-issued sessions must use the FID company switcher; anyone
  // landing here (either via our own redirect when `!selectedCompany` or
  // directly navigating to `/authentication/company_selector`) should be
  // bounced to id.*.  This is a cross-origin redirect so we trigger it
  // synchronously during render — returning `null` below avoids a flash of
  // the monolith selector.
  if (isFactorialIdUser()) {
    redirectToFactorialIdCompanySelector()
    return null
  }

  if (companies.selected) return <Navigate to={navigation.path} />

  return (
    <Box width="full" height="full" alignItems="center" justifyContent="center">
      <Box width="s600" alignItems="center" justifyContent="center">
        <Box maxWidth="s400" textAlign="center">
          <Title
            title={i18n.t('authentication.company_selector.title')}
            illustration="logo-avatar"
            centered
            description={i18n.t('authentication.company_selector.description')}
          />
        </Box>
        <CompanySelector isFullPage onChoose={handleChoice} />
      </Box>
    </Box>
  )
}

export default memo(CompanySelectorPage)
